import { Chip, styled } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { TrendBadgeArrows, TrendBadgeColors } from './trend-badge.types';
import { getTrendBadgePalette } from './trend-badge.utils';

const StyledChip = styled(Chip)<{ label: string }>(({ theme, label }) => ({
  fontSize: '1.2rem',
  fontWeight: 600,
  borderRadius: theme.spacing(0.5),
  height: theme.spacing(2.5),
  lineHeight: 1,
  padding: 0,
  '& .MuiChip-label': {
    display: label ? 'inline-block' : 'none',
  },
  '& .MuiChip-icon': {
    fontSize: '1.3rem',
    color: 'currentColor',
    strokeWidth: theme.spacing(0.1),
    stroke: 'currentColor',
    marginRight: label ? theme.spacing(-0.8) : theme.spacing(0.5),
  },
}));

export type TrendBadgeProps = {
  color?: TrendBadgeColors;
  arrow?: TrendBadgeArrows;
  label: string;
};

export const TrendBadge = ({ label, arrow, color = 'gray' }: TrendBadgeProps) => {
  return (
    <StyledChip
      icon={arrow ? arrow === 'up' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon /> : undefined}
      label={label}
      size='small'
      variant='filled'
      sx={(theme) => {
        const palette = getTrendBadgePalette(theme, color);
        return {
          color: palette.foreground,
          backgroundColor: palette.background,
        };
      }}
    />
  );
};
